import React from 'react';
import { AnimatedSkeletonLoader } from '@/components/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { RestaurantInfoHeaderSkeleton } from './restaurant-info-header-skeleton';
import { View } from 'react-native';

export const HubInsightsSectionSkeleton = () => {
  const [styles] = useStyles();

  return (
    <View accessibilityState={{ busy: true }} style={styles.container}>
      <View>
        <AnimatedSkeletonLoader height={16} width={123} />
      </View>
      <View>
        {Array.from({ length: 3 }).map((_, index) => (
          <RestaurantInfoHeaderSkeleton key={index} />
        ))}
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderRadius: 12,
    gap: 21,
    padding: 16,
    width: '100%',
  },
}));
